import React from 'react'
import logo from "../assets/logo.png";
import { AdminLogIn } from '../components/forms/AdminLogIn';

export const LogIn = () => {
    return (
        <main className='min-h-[100vh] flex justify-around items-center md:flex-row flex-col bg-black'>
            <div className='md:w-[40%] w-[80%]'>
                <img src={logo} alt="Logo ogf N6T" className='w-full h-full' />
            </div>
            <div className="log-in md:w-[40%] w-[80%] rounded-xl flex flex-col items-center justify-center p-[10px] h-fit">
                <AdminLogIn />
            </div>
        </main>
    )
}
